// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__35wdE","info":"Footer_info__2h2NT","list":"Footer_list__1kMKM"};